export default "__VITE_ASSET__BQEjBNxP__"